import { create } from 'zustand';
import type { StoreApi, UseBoundStore } from 'zustand';
import { createChatSlice, type ChatSet, type ChatSlice } from './chatSlice';

/**
 * A chat's own store, for a chat docked beside a page.
 *
 * A factory rather than a singleton: each docked chat keeps its own thread,
 * messages and turn, so a dashboard conversation and a monitor conversation
 * cannot bleed into one another. Everything in it is the shared chat slice;
 * only the starting title differs.
 */
export interface ChatStore extends ChatSlice {
  loadHistoryShell: (payload: {
    messages: ChatSlice['messages'];
    artifacts: ChatSlice['workspaceTabs'];
    timeline: ChatSlice['timeline'];
  }) => void;
}

export type ChatStoreHook = UseBoundStore<StoreApi<ChatStore>>;

export function createChatStore(initialTitle: string | null = null): ChatStoreHook {
  return create<ChatStore>()((set) => ({
    ...createChatSlice(set as ChatSet),
    threadTitle: initialTitle,
    loadHistoryShell: ({ messages, artifacts, timeline }) =>
      set({
        messages,
        workspaceTabs: artifacts,
        timeline,
        streamingContent: '',
        streamingAction: '',
        streamingStatuses: [],
        isStreaming: false,
      }),
  }));
}
